import React from 'react';
import { DocusealBuilder } from '@docuseal/react';

const DocuSignPage = () => {
  const token = 'YOUR_DOCUSEAL_BUILDER_TOKEN'; // Replace with a valid token

  const handleLoad = (detail) => {
    console.log('Builder loaded', detail);
  };

  const handleSave = (detail) => {
    console.log('Document saved', detail);
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">DocuSeal Builder</h2>
      <DocusealBuilder
        token={token}
        withSendButton={true}
        withTitle={true}
        autosave={true}
        language="en"
        roles={['Signer', 'Viewer']}
        backgroundColor="#f4f4f4"
        onLoad={handleLoad}
        onSave={handleSave}
        style={{ height: '80vh', border: '1px solid #ddd' }}
      />
    </div>
  );
};

export default DocuSignPage;
